module.exports = __webpack_public_path__ + "img/background_5.0b3a92eb.jpg";